import { getToken, setToken, removeToken } from '@/utils/Token';
import {
  passwordLogin,
  codeLogin,
  getuser,
  onekeylogin,
  WechatLogin
} from '@/api/user'
import { getUserInte, getUsersurplusApi } from '@/api/pay'
import router from '@/router'

function TokenHandle(data) {
	const {
    token,
    refresh_token,
    refresh_token_expiresat,
    expiresat
  } = data
	setToken({
		Token: token,
		Refresh_token: refresh_token,
		Refresh_token_expiresat: refresh_token_expiresat,
		Expiresat: expiresat,
  });
}

const state = {
	token: getToken(),
	userInfo: '',
  userInte: '',
  userSurplus: ''
};

const mutations = {
	SET_TOKEN: (state, token) => {
		state.token = token;
	},
	SET_USERINFO: (state, userInfo) => {
		state.userInfo = userInfo;
	},
	set_user_inte: (state, userInte) => {
		state.userInte = userInte;
  },
  SET_USER_SURPLUS: (state, userSurplus) => {
		state.userSurplus = userSurplus;
  }
};

const actions = {
  // 一键登录
  oneKeyLogin({ state }, userInfo) {
    const { phone, code } = userInfo
    return new Promise((resolve, reject) => {
      onekeylogin({
        phone: phone,
        code: code,
        wechatKey: state.wechatkey
      })
        .then(response => {
          TokenHandle({
            token: response.data.data.token,
            refresh_token: response.data.data.refresh_token,
            refresh_token_expiresat: response.data.data.refresh_token_expiresat,
            expiresat: response.data.data.expiresat
          })
          // setToken({
          //   authorization: response.data.data.token,
          //   refresh_token: response.data.data.refresh_token,
          //   refresh_token_expiresat:
          //     response.data.data.refresh_token_expiresat,
          //   expiresat: response.data.data.expiresat
          // })
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 密码登录
  passwordLogin(state, userInfo) {
    const { phone, password } = userInfo
    return new Promise((resolve, reject) => {
      passwordLogin({ username: phone, password: password })
        .then(response => {
          TokenHandle(response.data.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 验证码登录
  codeLogin(state, userInfo) {
    const { phone, code } = userInfo
    return new Promise((resolve, reject) => {
      codeLogin({ phone: phone, code: code })
        .then(response => {
          TokenHandle(response.data.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取用户信息
  getUserInfo ({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.userInfo === '') {
        getuser()
          .then(response => {
            if (response.data.headimg == '') {
              response.data.headimg = require('../../assets/1.jpg')
            }
            commit('SET_USERINFO', response.data.data)
            resolve(state.userInfo)
          })
          .catch(error => {
            reject(error)
          })
      } else {
        resolve(state.userInfo)
      }
    })
	},
	// 微信登录
	async wechatLogin ({ state }, wxCode) {
		 const result = await WechatLogin({
       code: wxCode
		 })
    if (result.data.data.status) {
      
      TokenHandle(result.data.data)
      return result
		}
		return result.data.data
	},
  // 退出登录
  loginOut() {
    removeToken()
    sessionStorage.clear()
    router.replace({
      path: '/login'
    })
  },
  async getInte({ commit, state }) {
    const result = await getUserInte()
    commit('set_user_inte', result.data.data.inte)
  },
  async getUsersurplus ({ commit, state }) {
    const result = await getUsersurplusApi()
    commit('SET_USER_SURPLUS', result.data.data.surplus)
  } 
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
};
